import { f7 } from 'framework7-react';
import { fetchMAffiliateSettingsApi } from '@/api/infoApi';
import { isApp, isIPhone } from '@/config/device';
import { themeId as THEME_ID } from '@/consts/shop';

// 移行案内を出す対象ブランドの themeId（プラウド・渥美モータース）
const MIGRATION_TARGET_THEME_IDS: number[] = [THEME_ID.PROUD, THEME_ID.ATSUMI];

// 標準版「マイくる」のストアURL取得元の加盟店ID
const STANDARD_AFFILIATE_ID = 1;

// path_type=2: ネイティブが onShouldStartLoadWithRequest で横取りし外部で開く
// （2025-04〜本番稼働・実機検証済みの経路）
const openExternal = (url: string) => {
  const sep = url.includes('?') ? '&' : '?';
  window.open(`${url}${sep}path_type=2`, '_blank');
};

/** ブランドアプリ内ログイン時にアプリ移行を促す */
export const maybeShowMigrationPrompt = async () => {
  // if (!isApp) return; // ネイティブアプリ内のみ（Webブラウザは対象外）【ブラウザ確認用に一時コメントアウト】

  const themeParam = Number(
    new URLSearchParams(window.location.search).get('theme'),
  );
  if (!MIGRATION_TARGET_THEME_IDS.includes(themeParam)) return;

  // 標準版「マイくる」(m_affiliate_id=1) のストアURLを取得
  let storeUrl = '';
  try {
    const res = await fetchMAffiliateSettingsApi({
      m_affiliate_id: STANDARD_AFFILIATE_ID,
    });
    const settings = res?.data?.data;
    storeUrl = (isIPhone ? settings?.ios_url : settings?.android_url) ?? '';
  } catch (e) {
    console.error(e);
  }
  if (!storeUrl) return; // URL取得失敗時はダイアログを出さない

  f7.dialog
    .create({
      title: 'アプリ移行のお願い',
      text: 'このアプリは提供終了を予定しています。今後は「マイくる」アプリをご利用ください。同じID・パスワードで、これまでのご契約・車両情報をそのままご確認いただけます。',
      buttons: [
        {
          text: 'アプリを入手',
          bold: true,
          onClick: () => openExternal(storeUrl),
        },
      ],
    })
    .open();
};
